/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Alpha_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Alpha video export failed: {error}" |
*
* @param {Video_Export_Alpha_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_failed_toast = /** @type {((inputs: Video_Export_Alpha_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'exportation video alpha : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Alpha-Videoexport fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione video Alpha non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео не удался: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la exportación del video alfa: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Alpha 视频导出失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アルファビデオのエクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अल्फा वीडियो निर्यात विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A exportação do vídeo alfa falhou: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Alpha video export failed: ${i?.error}`)
});